export default __webpack_public_path__ + "visionaac0ea.png";